import Typo from "@/src/components/atom/Typo";
import { ColDef, ValueGetterParams } from "ag-grid-community";
import dayjs from "dayjs";
import { renderSubscriptionStatusBadge } from "../utils/renderSubscriptionStatusBadge";
import { planStatusStrings } from "../utils/transformStatusStrings";
import {
  getFormattedTimezoneDateWithOffset,
  getTimezoneDateWithOffset,
} from "@/src/hooks/useCompanyLocalDate";
import { SubscriptionStatusType } from "@/src/store/apis/subscription/interface";

export const columnSubscriptionList: ColDef[] = [
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "subscriptionType",
    sortable: false,
    flex: 1,
    minWidth: 160,
    cellRenderer: (params: ValueGetterParams) => {
      const isFreeType = params.data.subscriptionType === "FREE";

      return params.data ? (
        <Typo typoType="b9r">
          {isFreeType
            ? planStatusStrings({
                t: params.data.t,
                type: params.data.subscriptionType,
              })
            : planStatusStrings({
                t: params.data.t,
                type: params.data.plan.planType,
              })}
        </Typo>
      ) : (
        "-"
      );
    },
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "planName",
    sortable: false,
    flex: 1,
    minWidth: 448,
    cellRenderer: (params: ValueGetterParams) => {
      return params.data.plan ? (
        <Typo typoType="b9r">{params.data.plan.name}</Typo>
      ) : (
        "-"
      );
    },
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "subscriptionStartAtFrom",
    flex: 1,
    minWidth: 140,
    sortable: false,
    cellRenderer: (params: ValueGetterParams) => {
      const gmtOffset = params.data?.gmtOffset;

      if (params.data.subscriptionStartAtFrom) {
        return (
          <Typo typoType="b9r">
            {getFormattedTimezoneDateWithOffset({
              date: params.data.subscriptionStartAtFrom,
              gmtOffset,
            })}
          </Typo>
        );
      } else {
        return "-";
      }
    },
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "subscriptionEndAtTo",
    flex: 1,
    minWidth: 140,
    sortable: false,
    cellRenderer: (params: ValueGetterParams) => {
      const gmtOffset = params.data?.gmtOffset;

      if (params.data.subscriptionEndAtTo) {
        return (
          <Typo typoType="b9r">
            {getFormattedTimezoneDateWithOffset({
              date: params.data.subscriptionEndAtTo,
              gmtOffset,
            })}
          </Typo>
        );
      } else {
        return "-";
      }
    },
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "usedLoadingCredit",
    flex: 1,
    minWidth: 180,
    sortable: false,
    cellRenderer: (params: ValueGetterParams) => {
      return params.data.credit ? (
        <Typo typoType="b9r">
          {params.data.credit.availableCredit}/
          {params.data.credit.totalCredit}
        </Typo>
      ) : (
        "-"
      );
    },
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "usedMember",
    flex: 1,
    minWidth: 100,
    sortable: false,
    cellRenderer: (params: ValueGetterParams) => {
      return params.data.memberNumberCredit ? (
        <Typo typoType="b9r">
          {params.data.planVersion.numberOfMember -
            params.data.memberNumberCredit}
          /{params.data.planVersion.numberOfMember}
        </Typo>
      ) : (
        "-"
      );
    },
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    field: "subscriptionStatus",
    flex: 1,
    minWidth: 90,
    sortable: false,
    cellRenderer: (params: ValueGetterParams) => {
      const t = params.data.t;
      const session = params.context?.session;
      const gmtOffset = session?.currentData?.row.exporter.gmtOffset || 0;

      if (params.data) {
        const today = getTimezoneDateWithOffset({
          date: dayjs(),
          gmtOffset,
        });
        const endDate = getTimezoneDateWithOffset({
          date: params.data.subscriptionEndAtTo as string,
          gmtOffset,
        });

        const duration = endDate.diff(today, "days");
        const isProgress = params.data.subscriptionStatus === "PROGRESS";

        let subscriptionStatus: SubscriptionStatusType;
        /**
         * 구독 종료일이 지났고
         * 현재 상태가 "진행중"일 때
         * 항상 "진행중"상태
         */
        subscriptionStatus =
          duration < 0 && isProgress
            ? "PROGRESS"
            : (params.data.subscriptionStatus as SubscriptionStatusType);

        return renderSubscriptionStatusBadge({
          t,
          type: subscriptionStatus,
          subscriptionType: params.data.subscriptionType,
          showFreeBadge: false,
        });
      } else {
        return "-";
      }
    },
  },
];
